export const safeWebsiteIconsSrcMap = {
  trustpilot: { name: "Trustpilot.svg" },
  feedaty: { name: "Feedaty.svg" },
  healthyMinister: { name: "HealthyMinister.svg" }
}

export type SafeWebsiteIconName = keyof typeof safeWebsiteIconsSrcMap

export const paymentIconsSrcMap = {
  visa: { name: "PaymentVisa.svg" },
  visaElectron: { name: "PaymentVisaElectron.svg" },
  paypal: { name: "PaymentPayPal.svg" },
  mastercard: { name: "PaymentMastercard.svg" },
  maestro: { name: "PaymentMaestro.svg" },
  threePay: { name: "PaymentThreePay.svg" },
  applePay: { name: "PaymentApplePay.svg" },
  googlePayWhite: { name: "PaymentGooglePay.svg" },
  googlePayBlack: { name: "PaymentGPayBlack.svg" },
  bonifico: { name: "PaymentBonifico.svg" },
  postePayApp: { name: "PaymentPostePayApp.svg" },
  postePay: { name: "PaymentPostePay.svg" }
}

export type PaymentIconName = keyof typeof paymentIconsSrcMap

export const shipmentIconsSrcMap = {
  gls: { name: "Gls.svg" }
}

export type ShipmentIconName = keyof typeof shipmentIconsSrcMap
